@if (asyncApiForm) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="asyncApiForm">
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Name </label>
            </div>
            <ng-container
            *ngTemplateOutlet="validators; context: { myControlName: 'name', myForm: asyncApiForm}"></ng-container>
            <input class="control-input" activeForm [activeForm]="asyncApiForm" id="name"
              [formControlName]="'name'" placeholder="Enter name"/>
            </div>
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Description </label>
              </div>
              <ng-container
              *ngTemplateOutlet="validators; context: { myControlName: 'description', myForm: asyncApiForm}"></ng-container>
              <input class="control-input" activeForm [activeForm]="asyncApiForm" id="description"
                [formControlName]="'description'" placeholder="Enter description"/>
              </div>
              <div class="control-div">
                <div class="control-label-container">
                  <label class="control-label"> Response Http Status </label>
                </div>
                <ng-container
                *ngTemplateOutlet="validators; context: { myControlName: 'responseHttpStatus', myForm: asyncApiForm}"></ng-container>
                <input class="control-input" activeForm [activeForm]="asyncApiForm" id="responseHttpStatus"
                  [formControlName]="'responseHttpStatus'" placeholder="Enter status code"/>
                </div>
                <div class="control-div">
                  <ng-container [ngTemplateOutlet]="responseHeaders"></ng-container>
                </div>
                <div class="control-div">
                  <div class="control-label-container">
                    <label class="control-label"> Response Body </label>
                  </div>
                  <ng-container
                  *ngTemplateOutlet="validators; context: { myControlName: 'responseBody', myForm: asyncApiForm}"></ng-container>
                  <textarea class="control-textArea" activeForm [activeForm]="asyncApiForm" id="responseBody"
                    [formControlName]="'responseBody'"
                  placeholder="Enter a body text"></textarea>
                </div>
              </ng-container>
            </ng-container>
          </clickatell-expansion-panel>
          <clickatell-expansion-panel>
            <ng-container header>
              <mat-panel-title>
                Logic
              </mat-panel-title>
            </ng-container>
            <ng-container body>
              <ng-container>
                <div class="control-div">
                  <label class="control-label"> Point To </label>
                  <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                  @if (nodeFlowDetails) {
                    <next-selector [canEditFlows]="canEdit.canEditFlows" [selectorType]="'both'"
                      [flowSteps]="nodeFlowDetails.currentFlowSteps" [flows]="nodeFlowDetails.flows"
                      [name]="'next'"
                      [form]="asyncApiForm"
                      [stepId]="nodeFlowDetails.stepId">
                    </next-selector>
                  }
                </div>
              </ng-container>
            </ng-container>
          </clickatell-expansion-panel>
        </div>
      }

      <ng-template #validators let-myControlName="myControlName" let-myForm=myForm>
        @if (myForm.controls[myControlName]; as control) {
          @if (control.invalid && (control.dirty || control.touched)) {
            <div class="validationField">
              @for (error of control.errors | keyvalue; track error) {
                <div>
                  <span class="fa fa-exclamation-circle"></span>
                  <span [id]="'validationField-' + myControlName">
                    {{error.value}}
                  </span>
                </div>
              }
            </div>
          }
        }
      </ng-template>

      <ng-template #responseHeaders>
        <div class="header-form" [formGroup]="asyncApiForm">
          <div (click)="addHeader()" class="add-header-btn">
            <div class="add-header-btn-icon">
              <img src="assets/svg/addIcon.svg">
            </div>
            <div class="add-header-btn-text">Add header</div>
          </div>
          <ng-container formArrayName="responseHeaders">
            @for (headerForm of headers.controls; track headerForm; let i = $index) {
              <div class="header-item">
                <div class="header-form-header">
                  <label class="control-label"> Header </label>
                  <button class="delete-btn" (click)="deleteHeader(i)"></button>
                </div>
                <div class="header-form-row" [formGroup]="headerForm">
                  <input class="control-input" style="margin-right: 5px" activeForm [activeForm]="headerForm" id="key"
                    formControlName="key" placeholder="Enter key"/>
                    <input class="control-input" activeForm [activeForm]="headerForm" id="value"
                      formControlName="value" placeholder="Enter value"/>
                    </div>
                  </div>
                }
              </ng-container>
            </div>
          </ng-template>